/**
 * Terms of Use / Användarvillkor
 * Source: /Information/Terms/terms_of_use_v1_*.md
 */

export const termsOfUseSV = `# Användarvillkor för Beredskapshubben

**Senast uppdaterad:** 2026-03-07

Dessa användarvillkor ("Villkoren") reglerar din användning av Beredskapshubben och tillhörande tjänster. Genom att registrera konto eller använda Tjänsten accepterar du Villkoren.

---

# 1. Företagsinformation

Tjänsten tillhandahålls av:

**Beredskapshubben Norden AB**
Org.nr: 559575-3343
Adress: Örebro, Sverige
E-post: [support@beredskapshubben.se](mailto:support@beredskapshubben.se)
("Beredskapshubben", "vi", "oss")

---

# 2. Definitioner

I dessa Villkor avses med:

**Tjänsten** – Beredskapshubbens webbplats, appar och funktioner
**Användare** – registrerad användare
**Innehåll** – text, checklistor, data, bilder, meddelanden, listor, profiler
**Premium** – betalversion av Tjänsten
**Konto** – registrerad användarprofil

---

# 3. Tjänstens syfte och viktiga säkerhetsförbehåll

Beredskapshubben är ett digitalt stödverktyg för hemberedskap och planering.

Beredskapshubben är en privat tjänst och är inte en officiell myndighetsapp. Tjänsten företräder inte någon myndighet och har inget uppdrag att agera för svenska myndigheters räkning.

Tjänsten:

* är vägledande
* ersätter inte myndighetsinformation
* ersätter inte professionell rådgivning
* ersätter inte krisledning

Beslut du fattar baserat på Tjänsten sker på egen risk.

Vid nödsituation ska alltid officiella myndigheters instruktioner följas.

---

# 4. Behörighet och ålder

Du måste vara minst **16 år** för att använda Tjänsten.

Användare under 18 år måste ha vårdnadshavares godkännande.

Du intygar att lämnade uppgifter är korrekta.

---

# 5. Konto och säkerhet

Du ansvarar för:

* riktiga kontouppgifter
* skydd av inloggningsuppgifter
* all aktivitet på kontot
* att omedelbart rapportera obehörig användning

Inloggning sker via engångskoder som skickas till registrerad e-postadress.

Vi får stänga konton med falska uppgifter eller missbruk.

Ett konto per fysisk person.

---

# 6. Tillåten användning

Tjänsten får användas för:

* hemberedskapsplanering
* familje- och gruppsamordning
* kunskapsdelning
* lagerhantering
* checklistor och planering

---

# 7. Förbjuden användning

Du får inte:

* bryta mot lag
* sprida hot eller trakasserier
* sprida medvetet felaktig krisinformation
* utge dig för annan person eller myndighet
* försöka hacka eller störa system
* använda bots eller scraping utan tillstånd
* samla in andras personuppgifter
* sprida skadlig kod
* använda tjänsten kommersiellt utan avtal
* publicera instruktioner för våld eller sabotage
* missbruka kris- eller säkerhetsfunktioner

---

# 8. Användargenererat innehåll

Du behåller äganderätten till ditt innehåll.

Du ger oss en global, royaltyfri licens att:

* lagra
* visa
* överföra
* bearbeta tekniskt
* visa för valda grupper/användare
* anonymisera för analys och produktförbättring

Du garanterar att:

* du har rätt att publicera innehållet
* det inte bryter mot lag
* det inte kränker tredje part

---

# 9. Moderering

Vi har rätt att:

* granska innehåll
* ta bort innehåll
* begränsa spridning
* stänga konton
* blockera grupper

Vid allvarliga överträdelser eller säkerhetsrisk kan detta ske utan förvarning.
När det är möjligt informerar vi om skälen och hur du kan kontakta support för omprövning.

---

# 10. Social interaktion

Vi ansvarar inte för:

* användares beteende
* gruppbeslut
* råd mellan användare
* åtgärder baserade på användarinnehåll

---

# 11. Immateriella rättigheter

All kod, design, struktur och varumärken tillhör oss eller våra licensgivare.

Du får inte:

* kopiera tjänsten
* reverse-engineera
* sälja vidare
* återpublicera material

---

# 12. Tredjepartstjänster

Tjänsten kan använda tredjepartsleverantörer och API:er.

Vi ansvarar inte för dessa tjänsters funktion eller säkerhet.

---

# 13. Betaltjänster och Premium

Premiumfunktioner kräver betalning.

Villkor:

* priser visas före köp
* abonnemang förnyas automatiskt
* betalning sker i förskott
* utebliven betalning kan stoppa tillgång

---

# 14. Ångerrätt (digital tjänst)

Du har 14 dagars ångerrätt enligt konsumentlag.

Om du uttryckligen godkänner att Premium aktiveras direkt upphör ångerrätten vid start av leverans.

Detta godkännande ska ske vid köp.

---

# 15. Prisändringar

Prisändringar meddelas minst 30 dagar i förväg.

---

# 16. Tillgänglighet

Vi garanterar inte oavbruten drift.

Avbrott kan ske vid:

* underhåll
* säkerhetsincident
* tekniska fel
* överbelastning

---

# 17. Säkerhetsåtgärder

Vid säkerhetsrisk kan vi:

* begränsa funktioner
* stänga tjänsten
* återställa data
* blockera konton

---

# 18. Dataportabilitet

Du kan begära export av dina data där tekniskt möjligt.

---

# 19. Personuppgifter

Personuppgifter behandlas enligt Integritetspolicyn och GDPR.

---

# 20. Force majeure

Vi ansvarar inte för händelser utanför vår kontroll, exempelvis:

* naturkatastrof
* krig
* myndighetsbeslut
* cyberangrepp
* el- eller nätavbrott

---

# 21. Ansvarsbegränsning

Tjänsten tillhandahålls "i befintligt skick".

Vi ansvarar inte för:

* indirekta skador
* följdskador
* förlorade data
* beslut baserade på tjänsten

Maximalt ansvar begränsas till vad du betalat senaste 12 månaderna.

Begränsningen gäller inte vid uppsåt eller grov vårdslöshet.

---

# 22. Uppsägning av konto

Du kan när som helst avsluta kontot.

Vi kan avsluta eller stänga konto vid:

* regelbrott
* missbruk
* säkerhetsrisk
* lagkrav
* avveckling av tjänsten

---

# 23. Efter uppsägning

Efter uppsägning:

* åtkomst upphör
* data kan raderas enligt policy
* aktiv period återbetalas normalt inte

Detta påverkar inte tvingande rättigheter enligt konsumentlagstiftning.

---

# 24. Ändringar av tjänst och villkor

Vi får ändra:

* funktioner
* innehåll
* priser
* villkor

Väsentliga ändringar meddelas via app eller e-post.

Om en ändring väsentligt påverkar dina rättigheter eller skyldigheter meddelas den minst 30 dagar innan ikraftträdande.
Om du inte accepterar ändringen kan du avsluta kontot innan ändringen börjar gälla.

---

# 25. Tillämplig lag

Svensk lag gäller.

EU-konsumenters tvingande rättigheter påverkas inte.

---

# 26. Tvister

Tvister kan prövas av:

* Allmänna Reklamationsnämnden
* svensk domstol

---

# 27. Kontakt

[support@beredskapshubben.se](mailto:support@beredskapshubben.se)

---`;

export const termsOfUseEN = `# Terms of Use for Beredskapshubben

**Last updated:** 2026-03-07

These Terms of Use ("Terms") govern your use of Beredskapshubben and related services. By registering an account or using the Service, you accept these Terms.

---

# 1. Company Information

The Service is provided by:

**Beredskapshubben Norden AB**
Company registration number: 559575-3343
Address: Örebro, Sweden
Email: [support@beredskapshubben.se](mailto:support@beredskapshubben.se)
("Beredskapshubben", "we", "us", "our")

---

# 2. Definitions

In these Terms:

**Service** – the Beredskapshubben website, applications, and features
**User** – a registered user
**Content** – text, checklists, data, images, messages, lists, profiles
**Premium** – paid version of the Service
**Account** – registered user profile

---

# 3. Purpose of the Service and Important Safety Disclaimer

Beredskapshubben is a digital support tool for household preparedness and planning.

Beredskapshubben is a private service and is not an official government app. The Service does not represent any government authority and has not been authorized to act on behalf of Swedish authorities.

The Service:

* is for guidance only
* does not replace government information
* does not replace professional advice
* does not replace emergency management

Any decisions you make based on the Service are at your own risk.

In emergencies, always follow official government authority instructions.

---

# 4. Eligibility and Age

You must be at least **16 years old** to use the Service.

Users under 18 must have guardian consent.

You confirm that the information you provide is accurate.

---

# 5. Account and Security

You are responsible for:

* accurate account information
* safeguarding your authentication credentials
* all activity under your account
* reporting unauthorized access immediately

Login is performed using one-time codes sent to your registered email address.

We may suspend accounts with false information or misuse.

One account per natural person.

---

# 6. Permitted Use

The Service may be used for:

* household preparedness planning
* family and group coordination
* knowledge sharing
* inventory tracking
* checklist and resource planning

---

# 7. Prohibited Use

You may not:

* violate any law
* harass or threaten others
* spread knowingly false crisis information
* impersonate individuals or authorities
* attempt unauthorized system access
* use bots or scraping tools without permission
* collect other users' personal data
* distribute malware
* use the Service commercially without agreement
* publish violent or sabotage instructions
* misuse emergency or safety features

---

# 8. User Generated Content

You retain ownership of your content.

You grant us a worldwide, royalty-free license to:

* store
* display
* transmit
* technically process
* share with selected users/groups
* anonymize for analytics and product improvement

You guarantee that:

* you have the right to publish it
* it does not violate law
* it does not infringe third-party rights

---

# 9. Moderation

We reserve the right to:

* review content
* remove content
* restrict distribution
* suspend accounts
* block groups

For serious violations or security risks, this may occur without prior notice.
Where possible, we inform you of the reasons and how to contact support for review.

---

# 10. Social Interaction

We are not responsible for:

* user behavior
* group decisions
* advice between users
* actions taken based on user content

---

# 11. Intellectual Property Rights

All code, design, structure, and trademarks belong to us or our licensors.

You may not:

* copy the Service
* reverse engineer
* resell
* republish materials

---

# 12. Third-Party Services

The Service may use third-party providers and APIs.

We are not responsible for their functionality or security.

---

# 13. Paid Services and Premium

Premium features require payment.

Conditions:

* prices shown before purchase
* subscriptions auto-renew
* payment in advance
* non-payment may suspend access

---

# 14. Right of Withdrawal (Digital Services)

Consumers have a 14-day withdrawal right under EU law.

If you expressly consent to immediate activation of Premium, the withdrawal right ends when delivery begins.

Such consent must be collected at purchase.

---

# 15. Price Changes

Price changes will be announced at least 30 days in advance.

---

# 16. Availability

We do not guarantee uninterrupted service.

Interruptions may occur due to:

* maintenance
* security incidents
* technical failures
* overload

---

# 17. Security Measures

In case of security risk, we may:

* restrict features
* shut down the Service
* restore data
* block accounts

---

# 18. Data Portability

You may request export of your data where technically feasible.

---

# 19. Personal Data

Personal data is processed according to the Privacy Policy and GDPR.

---

# 20. Force Majeure

We are not liable for events beyond our control, including:

* natural disasters
* war
* government actions
* cyberattacks
* power or network outages

---

# 21. Limitation of Liability

The Service is provided "as is".

We are not liable for:

* indirect damages
* consequential damages
* lost data
* decisions based on the Service

Maximum liability is limited to the amount you paid in the last 12 months.

This limitation does not apply to willful misconduct or gross negligence.

---

# 22. Account Termination

You may terminate your account at any time.

We may suspend or terminate accounts due to:

* rule violations
* misuse
* security risk
* legal requirements
* service discontinuation

---

# 23. After Termination

After termination:

* access ends
* data may be deleted per policy
* active periods are normally not refunded

This does not affect mandatory consumer rights under applicable law.

---

# 24. Changes to Service and Terms

We may change:

* features
* content
* prices
* terms

Material changes will be announced via app or email.

If a change materially affects your rights or obligations, it will be announced at least 30 days before taking effect.
If you do not accept the change, you may terminate your account before it takes effect.

---

# 25. Governing Law

Swedish law applies.

Mandatory EU consumer rights remain unaffected.

---

# 26. Disputes

Disputes may be brought before:

* Swedish National Board for Consumer Disputes (ARN)
* Swedish courts

---

# 27. Contact

[support@beredskapshubben.se](mailto:support@beredskapshubben.se)

---`;
